import { Tooltip } from 'devextreme-react/tooltip';

export const onExtensionCellRender = (e) => {
    const targetId = `extensionNumber_${e.data.id}`;
    return (
        <>
            <div
                data-tip
                data-for={targetId}
            >
                {e.data.extensionNumber}
            </div>
            <Tooltip
                target={`[data-for="${targetId}"]`}
                showEvent='mouseenter'
                hideEvent='mouseleave'
                hideOnOutsideClick={false}
            >
                Extension periods used
            </Tooltip>
        </>
    );
};
